import deleteWithToken from './base/delete-with-token'

const removeCustomerSiteContact = id => deleteWithToken(`/customer-contact/${id}/remove`)({})

export default removeCustomerSiteContact